import React from 'react';
import PropTypes from 'prop-types';
import { Button, Input } from 'antd';

const TextFilter = ({
  placeholder, onInputChange, onOkClick, onResetClick, value, inputRef
}) => {
  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    onInputChange(inputValue);
  };

  return (
    <div className="bhp-table-filter ant-table-filter-dropdown">
      <div className="bhp-input">
        <Input
          ref={inputRef}
          placeholder={placeholder}
          value={value}
          onChange={handleInputChange}
          onPressEnter={onOkClick}
        />
      </div>
      <div className="ant-table-filter-dropdown-btns">
        <Button className="ant-table-filter-dropdown-link confirm" onClick={onOkClick}>
          OK
        </Button>
        <Button className="ant-table-filter-dropdown-link clear" onClick={onResetClick}>
          Reset
        </Button>
      </div>
    </div>
  );
};

TextFilter.propTypes = {
  placeholder: PropTypes.string,
  value: PropTypes.string,
  inputRef: PropTypes.func,
  onInputChange: PropTypes.func,
  onOkClick: PropTypes.func,
  onResetClick: PropTypes.func
};

TextFilter.defaultProps = {
  placeholder: '',
  value: '',
  inputRef() {
  },
  onInputChange() {
  },
  onOkClick() {
  },
  onResetClick() {
  }
};

export default TextFilter;
